module.exports = __webpack_public_path__ + "static/img/service-intro-image.61cde14.jpg";